/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { identityEntity } from "./identity.entity"
import { entityEntity } from "./entity.entity"
import { relationEntity } from "./relation.entity"
import { eventEntity } from "./event.entity"
import { lifecycleEntity } from "./lifecycle.entity"
import { commandEntity } from "./command.entity"

export const entityRegistry = {

    identity: identityEntity,
    entity: entityEntity,
    relation: relationEntity,
    event: eventEntity,
    lifecycle: lifecycleEntity,
    command: commandEntity

}